module.exports = __webpack_public_path__ + "assets/images/COMMON_OWNER_LOGO_b8de93dc787aa460323e46ab7221436b.png";